{
  "general": {
    "print": "Stampa",
    "save_updates": "Salva modifiche"
  },
  "labels": {
    "part": "Ricambio",
    "car": "Automobile",
    "details": "Dettagli"
  },
  "clients": {
    "edit_title": "Modifica Cliente",
    "personal_data": "Dati Identificativi e fiscali",
    "name": "Nome",
    "surname": "Cognome",
    "license_plate": "Targa",
    "fiscal_code": "Codice Fiscale",
    "vat_number": "Partita IVA",
    "contacts": "Contatti",
    "email": "Email",
    "cellphone": "Numero di telefono",
    "landphone": "Telefono Fisso",
    "cellphone_duplicate": "Numero di telefono già presente"
  },
  "requests": {
    "back_to_requests": "Torna alle richieste",
    "save_and_back": "Salva senza inoltrare",
    "auto_management": "Gestione Autonoma",
    "send_request": "Invia Richiesta",
    "end_sale": "Concludi Vendita",
    "send_to_warehouse": "Invia al magazzino",
    "check_finished": "Controllo Concluso",
    "see_related_sell": "Vedi vendita collegata",
    "save_updates": "Salva modifiche",
    "save_check": "Salva Controllo",
    "previous": "Precedente",
    "next": "Successivo"
  },
  "parts": {
    "not_available": "Non Disponibile",
    "unsolded": "Invenduto",
    "add_image": "Aggiungi immagine",
    "remove_image": "Rimuovi Immagine",
    "add_part": "Aggiungi Ricambio",
    "add_option": "Aggiungi Opzione",
    "labels": {
      "new_option": "Nuova Opzione",
      "request_car": "Auto della richiesta",
      "request_notes": "Note",
      "car_maker": "Produttore",
      "car_model": "Modello",
      "car_version": "Versione",
      "car_side": "Lato auto",
      "part_name": "Nome ricambio",
      "part_price": "Prezzo",
      "part_color": "Colore",
      "part_code": "Codice Prodotto",
      "part_internal_code": "Codice Interno",
      "part_conditions": "Condizioni del prodotto",
      "part_shelf_position": "Posizione Scaffale"
    },
    "conditions": {
      "new": "Nuovo",
      "second_hand": "Usato",
      "refurbished": "Rigenerato"
    }
  }
}
